import React, { Component } from 'react'
import ControlSuger from './controlSuger'

class WechatShareScreen extends Component {
  render() {
    return (
      <div>
        <ControlSuger {...this.props} />
      </div>
    )
  }
}

export default WechatShareScreen


// WEBPACK FOOTER //
// ./src/modules/wechatShare/components/index.js